import React from 'react';
import UploadModal from '../../../../common/UploadModal';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false
        }
    }

    handleOpen = () => {
        this.setState({modalIsOpen: true});
    }

    handleClose = () => {
        this.setState({modalIsOpen: false});
    }

    onUploadSuccess = () => {
        this.setState({
            refetch: Math.random(),
            modalIsOpen: false
        });
    }

    render() {
        return (
            <div>
                Upload Voice Rates
                <button onClick={this.handleOpen} className="btn btn-upload">Upload Voice Rate Table</button>

                <UploadModal 
                    modalIsOpen={this.state.modalIsOpen} 
                    handleClose={this.handleClose} 
                    url_upload = "/admin/products/voice/rates/upload"
                    url_confirm = "/admin/products/voice/rates/confirm" 
                    modalTitle = "Upload Voice Rate Table"
                    onUploadSuccess = { this.onUploadSuccess.bind(this) }
                />
            </div>
        );
    }
}